import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { IEnrichedProduct } from '$models';
import { useIsSSR } from '$hooks';
import { brandLeg } from '$constants';

type Props = {
    selectedProduct: IEnrichedProduct;
};

export const FlixMedia = ({ selectedProduct }: Props) => {
    const { isSSR } = useIsSSR();
    useEffect(() => {
        if (!selectedProduct || isSSR) {
            return;
        }

        const script = document.createElement('script');

        script.src = '//media.flixfacts.com/js/loader.js';
        script.async = true;
        script.type = 'text/javascript';
        script.setAttribute('data-flix-distributor', brandLeg ? '18195' : '18192');
        script.setAttribute('data-flix-language', 'da');
        script.setAttribute('data-flix-ean', selectedProduct.product?.itemEanCode || '');
        script.setAttribute('data-flix-brand', selectedProduct.product?.productBrand || '');
        script.setAttribute('data-flix-button', 'flix-minisite');
        script.setAttribute('data-flix-inpage', 'flix-inpage');
        script.setAttribute('data-flix-price', selectedProduct.activePrice?.amount + '' || '');
        script.setAttribute('data-flix-fallback-language', 'en');

        // document.body.appendChild(script);
        document.getElementById('flix-media-container')?.appendChild(script);
        return () => {
            document.getElementById('flix-media-container')?.removeChild(script);
            const flixMinisite = document.getElementById('flix-minisite');
            if (flixMinisite) {
                flixMinisite.innerHTML = '';
            }

            const flixInpage = document.getElementById('flix-inpage');
            if (flixInpage) {
                flixInpage.innerHTML = '';
            }
        };
    }, [selectedProduct]);

    return (
        <div id="flix-media-container">
            <FlixMediaContainerWithStyle id="flix-minisite" />
            <FlixMediaContainerWithStyle id="flix-inpage" />
        </div>
    );
};

const FlixMediaContainerWithStyle = styled.div(({ theme }) => ({
    '& *': {
        fontFamily: theme.fontFamilies.regular + ' !important',
    },
}));
